import { Phone, MessageCircle, MapPin, Star, Info, AlertTriangle, Navigation } from "lucide-react";
import { BUSINESS } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

export const Contact = () => {
  const { openGate } = useContact();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="section-pad bg-white"
    >
      <div className="msc-container">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16">
          {/* Left intro */}
          <div>
            <span className="badge-trust">Sampark Karein</span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1F2937] leading-tight">
              Aap ka <span className="text-[#1E3A8A]">Sawaal,</span>{" "}
              <span className="text-[#D97706]">Hamara Jawab.</span>
            </h2>
            <p className="mt-4 text-[#4B5563] text-base sm:text-lg max-w-md">
              Humse judne ke liye niche diye gaye options ka istemal karein. Store par aana hamesha behtar hota hai!
            </p>

            <div className="mt-7 space-y-4">
              <button
                onClick={() => openGate()}
                data-testid="contact-enquiry-card"
                className="card-base w-full p-5 flex items-center gap-4 group text-left border-2 border-[#F59E0B] bg-[#F59E0B]/5 shadow-sm hover:shadow-md transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F59E0B] text-white flex items-center justify-center group-hover:scale-105 transition-transform">
                  <MessageCircle className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#D97706]">
                    Quick Connect
                  </div>
                  <div className="font-display font-bold text-lg text-[#1F2937]">
                    Start an Enquiry
                  </div>
                </div>
              </button>

              <a
                href="https://www.google.com/maps/place/MEHDI+SOAP+CENTER+(SABUN+WALE)/data=!4m2!3m1!1s0x0:0x5984df5d49ceb83b?sa=X&ved=1t:2428&ictx=111"
                target="_blank"
                rel="noreferrer"
                data-testid="contact-maps-card"
                className="card-base p-5 flex items-center gap-4 group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#1E3A8A]/10 text-[#1E3A8A] flex items-center justify-center group-hover:scale-105 transition-transform">
                  <Navigation className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#4B5563]">
                    Get Directions
                  </div>
                  <div className="font-display font-bold text-lg text-[#1F2937]">
                    Google Maps
                  </div>
                </div>
              </a>

              <a
                href="#locations"
                data-testid="contact-visit-card"
                className="card-base p-5 flex items-center gap-4 group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#25D366]/15 text-[#15803D] flex items-center justify-center group-hover:scale-105 transition-transform">
                  <MapPin className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#4B5563]">
                    Explore Stores
                  </div>
                  <div className="font-display font-bold text-lg text-[#1F2937]">
                    View 3 Branches
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* Direct message card */}
          <div className="card-base p-6 sm:p-8 flex flex-col justify-center bg-[#0B1733] text-white shadow-2xl relative overflow-hidden">
            {/* Background pattern */}
            <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-[#1E3A8A] rounded-full blur-3xl opacity-50 pointer-events-none"></div>
            
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-5">
                 <div className="p-2.5 bg-[#F59E0B]/20 rounded-xl border border-[#F59E0B]/30">
                    <Info className="w-6 h-6 text-[#FBBF24]" />
                 </div>
                 <h3 className="font-display font-black text-xl sm:text-2xl text-white">
                   Zaroori Suchna
                 </h3>
              </div>
              <div className="space-y-4">
                <p className="text-base text-white/80 leading-relaxed font-medium">
                  Agar aapko sirf <b className="text-[#FBBF24]">rate puchhne</b> hain ya <b className="text-[#FBBF24]">variety dekhni</b> hai, toh request hai ki message na karein. Hum aamne-saamne baat karne mein zyada khushi mehsoos karte hain, isliye sidhe hamari dukaan par aaiye!
                </p>
                <p className="text-base text-white/80 leading-relaxed font-medium">
                  Lekin agar aap sach mein <b className="text-white">order dena chahte hain</b>, ya <b className="text-white">wholesale bulk inquiry</b> hai, tabhi <span className="text-[#FBBF24]">Enquiry Form (Quick Connect)</span> ke through contact karein.
                </p>
              </div>

              <div className="mt-8 p-4 bg-white/10 rounded-xl border border-white/20 flex gap-3 items-start backdrop-blur-sm">
                <AlertTriangle className="w-5 h-5 text-[#EF4444] shrink-0 mt-0.5" />
                <p className="text-sm font-semibold text-white/90">
                  <span className="text-[#EF4444] font-bold">Closed on Sunday:</span> Hamari main branch Sunday ko band rehti hai, aur baaki branches bhi mostly band hi rehti hain. Kripya dhyan rakhein.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};